import React from 'react'
import { Button, Progress } from 'antd'
import { AiOutlineReload, AiOutlineUnorderedList } from 'react-icons/ai'
import i18n from '../../../../lib/i18n'
import antdTheme from '../../../../styles/antdTheme'
import styles from './Summary.module.scss'

// Final screen: score and the way back to the questions
function Summary({ total, correct, answered, onReview, onRestart }) {
  const percent = total ? Math.round((correct / total) * 100) : 0
  const color = percent >= 80 ? antdTheme.token.colorSuccess : percent >= 50 ? antdTheme.token.colorWarning : antdTheme.token.colorError

  return (
    <section className={styles.Summary} aria-live="polite">
      <Progress type="circle" percent={percent} strokeColor={color} size={140} />
      <h2 className={styles.title}>{i18n('qv_summary_title')}</h2>
      <p className={styles.text}>
        {i18n('qv_summary_correct')}: <b>{correct} / {total}</b>
        {answered < total && <><br />{i18n('qv_summary_skipped')}: <b>{total - answered}</b></>}
      </p>
      <div className={styles.actions}>
        <Button size="large" icon={<AiOutlineUnorderedList size={16} />} onClick={onReview}>
          {i18n('qv_review')}
        </Button>
        <Button type="primary" size="large" icon={<AiOutlineReload size={16} />} onClick={onRestart}>
          {i18n('qv_start_over')}
        </Button>
      </div>
    </section>
  )
}

export default Summary
